import { Field, ErrorMessage } from 'formik'

const Input = ({ children, type, name }) => {
    if(type !== 'checkbox'){
        return(
            <div>
                <label className='/ml-5 /font-bold text-white'>
                    {children}
                </label>
                <div className='flex flex-col items-center w-full mb-2'>
                    <Field autoFocus className='mt-1 block  w-full rounded-md border-gray-300 shadow-sm focus:border-secundario focus:ring-secundario sm:text-sm' name={name} type={type}/>
                    <ErrorMessage name={name} component='div' className='w-11/12 text-secundario text-xs font-bold text-right'/>
                </div>
            </div>
        )
    }
    else{
        return(
            <div className=''>
                <label className='/ml-5 mr-2 text-s /font-semibold text-blueGray-600'>{children}</label>
                <Field className='' name={name} type={type}/>
            </div>
        )
    }
}

export default Input